import React from 'react';
import { Section } from './Section';
import { ComparisonTable } from './ComparisonTable';
import { inactionRows } from '../data/tables';
export function CostOfInaction() {
  return <Section background="paper" labelledBy="inaction-heading" data-id="element-97" data-mp="2uy3rsw3brtr4">
      <h2 id="inaction-heading" className="text-center font-serif text-[26px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[40px]" data-id="element-98" data-mp="2uzx2cmh26y4e">
        What does the freeze actually cost you?
      </h2>

      <ComparisonTable className="mx-auto mt-10 max-w-4xl sm:mt-12" rows={inactionRows} leftLabel="Without the system" rightLabel="The real cost" variant="warn" data-id="element-99" data-mp="38xlk3lftxp58" />

      <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-xl font-medium italic leading-snug text-brass sm:mt-12 sm:text-2xl lg:text-[28px]" data-id="element-100" data-mp="3iny5ffvgxmcf">
        One class where you knew exactly what to say pays for this twenty times over.
      </p>
      <p className="mt-4 text-center font-sans text-[15px] font-semibold text-sage sm:text-[16px]" data-id="element-101" data-mp="3slufs5gl0d9h">
        The next student who walks up to you before class can go completely differently.
      </p>
    </Section>;
}